import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-leaf-50 bg-leaf-pattern">
      <AppHeader />

      {/* Main content with padding for header and bottom nav */}
      <main className="pt-14 pb-20 min-h-screen">
        <div className="max-w-lg mx-auto px-4 py-4">
          <Outlet />
        </div>
      </main>

      <BottomNav />
    </div>
  );
}
